import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappIcon = () => {
  return (
    <div className="fixed bottom-6 right-10 z-50">
      <a
        href="https://wa.me/918826831843" 
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-3 shadow-lg flex items-center justify-center "
      >
        <FaWhatsapp className="text-4xl" />
      </a>
    </div>
  );
};

export default WhatsappIcon;
